import StudyService from "../services/study.service.js";
import Config from "@/config/config.js";
import { getSession, setInSession } from "@/hooks/useSession.js";
import NavigationService from "../services/navigation.service.js";
import EmailController from "./email.controller.js";
import AuthService from "../services/auth.service.js";
import State, { STATE, CurrentStudyState, CurrentEntityState } from "@state";
import { sha256 } from "@/utils/crypto.js";


const getStudiesByUserId = async (userId) => {
  console.log("=== userId === study.controller.js === key: 457114 ===");
  console.dir(userId, { depth: null, colors: true });
  console.log("=================================");

  try {
    const response = await StudyService.getStudiesByUserId(userId);
    console.log("=== response === study.controller.js === key: 109623 ===");
    console.dir(response, { depth: null, colors: true });
    console.log("=================================");
    return response;
  } catch (error) {
    return {
      success: false,
      message: "Error fetching study",
      fromError: !Config.IN_PROD ? error.message : null,
      errorCode: "get-study-by-userid-error",
      errorKey: 469947,
    };
  }
};

const getStudiesByEntityId = async (entityId) => {
  console.log("=== entityId === study.controller.js === key: 343955 ===");
  console.dir(entityId, { depth: null, colors: true });
  console.log("=================================");

  try {
    const response = await StudyService.getStudiesByEntityId(entityId);
    console.log("=== response === study.controller.js === key: 486612 ===");
    console.dir(response, { depth: null, colors: true });
    console.log("=================================");
    return response;
  } catch (error) {
    return {
      success: false,
      message: "Error fetching study",
      fromError: !Config.IN_PROD ? error.message : null,
      errorCode: "get-study-by-entity-id-error",
      errorKey: 106645,
    };
  }
};

const registerStudy = async () => {
  const session = getSession();



  const email = await sha256(session.user.email);



  const studyData = {
    entityDIDAddress: STATE[CurrentEntityState.CURRENT_ENTITY_DATA].did_address,
    title: STATE[CurrentStudyState.STUDY].name,
    description: STATE[CurrentStudyState.STUDY].name,
    status: "started",
    latenceTime: 1,
  };

  console.log("=== studyData === study.controller.js === key: 036813 ===");
  console.dir(studyData, { depth: null, colors: true });
  console.log("=================================");

  console.log('=== STATE === study.controller.js === key: 424586 ===');
  console.dir(STATE, { depth: null, colors: true })
  console.log('=================================');



  const tmpKeyRes = await AuthService.getTmpApiKey(email);
  if (tmpKeyRes?.success === false) {
    console.log("=== tmpKeyRes === study.controller.js === key: 668709 ===");
    console.dir(tmpKeyRes, { depth: null, colors: true });
    console.log("=================================");
    return tmpKeyRes;
  }
  const xApiKey = tmpKeyRes;
  console.log("=== xApiKey === study.controller.js === key: 554222 ===");
  console.dir(xApiKey, { depth: null, colors: true });
  console.log("=================================");

  const webhookTokenRes = await AuthService.getWebhookToken(email);
  if (webhookTokenRes?.success === false) {
    console.log(
      "=== webhookTokenRes === study.controller.js === key: 757455 ==="
    );
    console.dir(webhookTokenRes, { depth: null, colors: true });
    console.log("=================================");
    return webhookTokenRes;
  }
  const webhookToken = webhookTokenRes;
  console.log("=== webhookToken === study.controller.js === key: 765617 ===");
  console.dir(webhookToken, { depth: null, colors: true });
  console.log("=================================");

  const masterIcfName = STATE[CurrentStudyState.MASTER_ICFS]?.[0]?.name;
  const masterIcfId = STATE[CurrentStudyState.MASTER_ICFS]?.[0]?.tmpId;

  const webhook = {
    url: `${Config.BACKEND_URL}/study/add`,
    method: "POST",
    delayed: true,
    params: {
      webhookToken,
      ...studyData,
      masterIcfName,
      masterIcfId,
      ownerEntityId: STATE[CurrentEntityState.CURRENT_ENTITY_ID],
      ...STATE[CurrentStudyState.STUDY],
    },
  };

  delete webhook.params.masterIcfs;
  delete webhook.params.milestones;

  studyData.webhook = webhook;

  //return webhook;

  const registerStudyRes = await StudyService.registerStudy(studyData, xApiKey);
  if (registerStudyRes?.success === false) {
    console.log(
      "=== registerStudyRes === study.controller.js === key: 088634 ==="
    );
    console.dir(registerStudyRes, { depth: null, colors: true });
    console.log("=================================");
    return registerStudyRes;
  }

  const currentStudy = {
    ...STATE[CurrentStudyState.STUDY],
    tmpId: registerStudyRes.studyId,
  };

  State.setValue(CurrentStudyState.STUDY, currentStudy);
  return { registerStudyRes, currentStudy };
};

const finaliseStudyRegistration = async () => {
  const session = getSession();
  const study = JSON.parse(JSON.stringify(STATE[CurrentStudyState.STUDY]));
  State.reset(CurrentStudyState);
  console.log('=== study === study.controller.js === key: 658134 ===');
  console.dir(study, { depth: null, colors: true })
  console.log('=================================');
  console.log('=== STATE === study.controller.js === key: 304163 ===');
  console.dir(STATE, { depth: null, colors: true })
  console.log('=================================');
  State.setValue(CurrentStudyState.STUDY, study);
}
  

const getRoleManagementCRO = async (studyId) => {
  console.log("=== studyId === study.controller.js === key: 192837 ===");
  console.dir(studyId, { depth: null, colors: true });
  console.log("=================================");

  try {
    const response = await StudyService.getRoleManagementCRO(studyId);
    console.log("=== response === study.controller.js === key: 473628 ===");
    console.dir(response, { depth: null, colors: true });
    console.log("=================================");
    return response;
  } catch (error) {
    return {
      success: false,
      message: "Error fetching role management settings",
      fromError: !Config.IN_PROD ? error.message : null,
      errorCode: "role-management-controller-error",
      errorKey: 562839,
    };
  }
};

const getInvestigatorStudiesByUserId = async (userId) => {
  console.log("=== userId === study.controller.js === key: 4579314 ===");
  console.dir(userId, { depth: null, colors: true });
  console.log("=================================");

  try {
    const response = await StudyService.getInvestigatorStudiesByUserId(userId);
    console.log("=== response === study.controller.js === key: 1090623 ===");
    console.dir(response, { depth: null, colors: true });
    console.log("=================================");
    return response;
  } catch (error) {
    return {
      success: false,
      message: "Error fetching study",
      fromError: !Config.IN_PROD ? error.message : null,
      errorCode: "get-investigator-studies-by-userID",
      errorKey: 793427,
    };
  }
};

const getInvestigatorStudyOverview = async ({ studyId, userId }) => {
  console.log("=== studyId === study.controller.js === key: 389729 ===");
  console.dir(studyId, { depth: null, colors: true });
  console.log("=================================");

  try {
    const response = await StudyService.getInvestigatorStudyOverview({ studyId, userId })
    console.log("=== response === study.controller.js === key: 556842 ===");
    console.dir(response, { depth: null, colors: true });
    console.log("=================================");
    return response;
  } catch (error) {
    return {
      success: false,
      message: "Error fetching InvestigatorStudyOverview",
      fromError: !Config.IN_PROD ? error.message : null,
      errorCode: "study-Investigator-Study-Overview",
      errorKey: 934718,
    };
  }
};

const getInvestigatorPatientsManagement = async (studyId) => {
  console.log("=== studyId === study.controller.js === key: 3349729 ===");
  console.dir(studyId, { depth: null, colors: true });
  console.log("=================================");

  try {
    const response = await StudyService.getInvestigatorPatientsManagement(
      studyId
    );
    console.log("=== response === study.controller.js === key: 5596842 ===");
    console.dir(response, { depth: null, colors: true });
    console.log("=================================");
    return response;
  } catch (error) {
    return {
      success: false,
      message: "Error fetching InvestigatorPatientsManagement",
      fromError: !Config.IN_PROD ? error.message : null,
      errorCode: "Investigator-Patients-Management",
      errorKey: 934318,
    };
  }
};

const getStudyMetricsCRO = async (studyId) => {
  console.log("=== studyId === study.controller.js === key: 457514 ===");
  console.dir(studyId, { depth: null, colors: true });
  console.log("=================================");

  try {
    const response = await StudyService.getStudyMetricsCRO(studyId);
    console.log("=== response === study.controller.js === key: 103623 ===");
    console.dir(response, { depth: null, colors: true });
    console.log("=================================");
    return response;
  } catch (error) {
    return {
      success: false,
      message: "Error fetching metrics",
      fromError: !Config.IN_PROD ? error.message : null,
      errorCode: "study-metrics-controller-error",
      errorKey: 793827,
    };
  }
};

const getStudyPatientsCRO = async (studyId) => {
  console.log("=== studyId === study.controller.js === key: 452514 ===");
  console.dir(studyId, { depth: null, colors: true });
  console.log("=================================");

  try {
    const response = await StudyService.getStudyPatientsCRO(studyId);
    console.log("=== response === study.controller.js === key: 101623 ===");
    console.dir(response, { depth: null, colors: true });
    console.log("=================================");
    return response;
  } catch (error) {
    return {
      success: false,
      message: "Error fetching latest enrollements",
      fromError: !Config.IN_PROD ? error.message : null,
      errorCode: "study-latest-entrolements-controller-error",
      errorKey: 795827,
    };
  }
};

const getStudyGeneralSettingsCRO = async (studyId) => {
  console.log("=== studyId === study.controller.js === key: 384729 ===");
  console.dir(studyId, { depth: null, colors: true });
  console.log("=================================");

  try {
    const response = await StudyService.getStudyGeneralSettingsCRO(studyId);
    console.log("=== response === study.controller.js === key: 556142 ===");
    console.dir(response, { depth: null, colors: true });
    console.log("=================================");
    return response;
  } catch (error) {
    return {
      success: false,
      message: "Error fetching general settings",
      fromError: !Config.IN_PROD ? error.message : null,
      errorCode: "study-general-settings-controller-error",
      errorKey: 934218,
    };
  }
};

const getMasterIcfSettingsCRO = async (studyId) => {
  console.log("=== studyId === study.controller.js === key: 728391 ===");
  console.dir(studyId, { depth: null, colors: true });
  console.log("=================================");

  try {
    const response = await StudyService.getMasterIcfSettingsCRO(studyId);
    console.log("=== response === study.controller.js === key: 491527 ===");
    console.dir(response, { depth: null, colors: true });
    console.log("=================================");
    return response;
  } catch (error) {
    return {
      success: false,
      message: "Error fetching Master ICF settings",
      fromError: !Config.IN_PROD ? error.message : null,
      errorCode: "master-icf-settings-controller-error",
      errorKey: 384726,
    };
  }
};

const getSiteSettingsCRO = async (studyId) => {
  console.log("=== studyId === study.controller.js === key: 618293 ===");
  console.dir(studyId, { depth: null, colors: true });
  console.log("=================================");

  try {
    const response = await StudyService.getSiteSettingsCRO(studyId);
    console.log("=== response === study.controller.js === key: 742519 ===");
    console.dir(response, { depth: null, colors: true });
    console.log("=================================");
    return response;
  } catch (error) {
    return {
      success: false,
      message: "Error fetching site settings",
      fromError: !Config.IN_PROD ? error.message : null,
      errorCode: "site-settings-controller-error",
      errorKey: 283746,
    };
  }
};

// ------------------------------
// Protocol version upload queue
// ------------------------------
/**
 * Envoie en série un tableau d’objets décrivant des versions de protocole (site ICF).
 * Chaque objet doit contenir au minimum:
 *  - masterIcfVersionId (title)
 *  - studyId
 *  - siteIcfFile (File | Blob)
 *  - siteIcfFileName (nom du fichier affiché côté API)
 *  - versionNumber, shortDescription (optionnel)
 * Les envois sont effectués un par un afin d'éviter la surcharge réseau et pour conserver l'ordre.
 * @param {Array<object>} protocols – tableau d’objets à envoyer
 * @returns {Promise<Array<object>>} – tableau de réponses API dans le même ordre
 */
const queuePatchProtocolVersions = async (_protocol , _studyId) => {
  const protocols = _protocol ? [_protocol] : STATE[CurrentStudyState.SITES]
  const studyId = _studyId ? _studyId : STATE[CurrentStudyState.STUDY].tmpId;
  const responses = [];
  const session = getSession();
  for (const proto of protocols) {
    const formData = new FormData();
    formData.append("title", proto.siteIcfFileName );
    formData.append("versionNumber",  "1.0.0");
    formData.append("shortDescription",  proto.siteIcfFileName );
    formData.append("studyId", studyId);

    // Fichier – s'assurer que c'est bien un File/Blob
    if (proto.siteIcfFile) {
      formData.append("file", proto.siteIcfFile, proto.siteIcfFileName);
    }

    // Obtenir une clé API temporaire unique pour chaque envoi
    const hashedEmail = await sha256(session.user.email);
    const tmpKeyRes = await AuthService.getTmpApiKey(hashedEmail);
    if (tmpKeyRes?.success === false) {
      responses.push(tmpKeyRes);
      continue;
    }
    const xApiKey = tmpKeyRes;

    try {
      const res = await StudyService.patchStudyProtocolVersion(formData, xApiKey);
      if(res.success!==false){
        proto.siteIcfId = res.protocolId;
        proto.integrityHash = res.integrityHash||"no-integrity-hash";
        delete proto.protocolId;
      }
      responses.push(res);
    } catch (err) {
      responses.push(err);
    }
  }
  return responses;
};

const updateProtocolVersionFile = async (data,file) => {
  const session = getSession();
  const hashedEmail = await sha256(session.user.email);
  const tmpKeyRes = await AuthService.getTmpApiKey(hashedEmail);
  if (tmpKeyRes?.success === false) {
    return tmpKeyRes;
  }
  const xApiKey = tmpKeyRes;

  console.log('=== data === study.controller.js === key: 856525 ===');
  console.dir(data, { depth: null, colors: true })
  console.log('=================================');

  const old_site_icf_id = data.site_icf_id

  const formData = new FormData();
  formData.append("title", file.name );
    formData.append("versionNumber",  "1.0.0");
    formData.append("shortDescription",  file.name );
    formData.append("studyId", data.study.id);  

    // Fichier – s'assurer que c'est bien un File/Blob
    if (file) {
      formData.append("file", file, file.name);
    }

    formData.forEach((value, key) => {
      console.log(`${key}:`, value);
    });

    

    const res = await StudyService.patchStudyProtocolVersion(formData, xApiKey);
      console.log('=== res === study.controller.js === key: 994401 ===');
      console.dir(res, { depth: null, colors: true })
      console.log('=================================');

      if(res.success===false){
        return res;
      }

      const sendData = { 
        old_site_icf_id,
        site_icf_id:res.protocolId, 
        study_id: data.study.id, 
        version_number: data.master_icf_version_name, 
        integrity_hash: res.integrityHash||"no-integrity-hash", 
        title: data.selectedMasterICF, 
        file_name: file.name, 
        master_icf_id: data.selectedMasterICF, 
        site_id: data.site_id 
      }

      const backendUpdated = await StudyService.updateBackendProtocolVersion(sendData);

      console.log('=== backendUpdated === study.controller.js === key: 994401 ===');
      console.dir(backendUpdated, { depth: null, colors: true })
      console.log('=================================');

  return backendUpdated;
}

// ------------------------------
// Study Sites upload queue
// ------------------------------
/**
 * Envoie en série les sites de l'étude à l'endpoint PATCH /study/site
 * Les données sont extraites de STATE[CurrentStudyState.SITES]
 * @returns {Promise<Array<object>>}
 */
const queuePatchSites = async (_site, _studyId) => {
  const sites = _site ? [_site] : STATE[CurrentStudyState.SITES];
  const studyId = _studyId ? _studyId : STATE[CurrentStudyState.STUDY].tmpId;
  const responses = [];
  const session = getSession();

  for (const site of sites) {
    // Construction du payload selon le schéma backend
    const payload = {
      studyId,
      ethicCommitteeID:  "unknown",
      name: site.siteName,
      postalAddress: site.siteAddress,
      city:  "",
      zipCode:  "",
      country:  "",
      longitude: "",
      latitude: ""
    };
    if (site.latitude) payload.latitude = site.latitude;
    if (site.longitude) payload.longitude = site.longitude;

    // Récupérer x-api-key temporaire
    const hashedEmail = await sha256(session.user.email);
    const tmpKeyRes = await AuthService.getTmpApiKey(hashedEmail);
    if (tmpKeyRes?.success === false) {
      responses.push(tmpKeyRes);
      continue;
    }
    const xApiKey = tmpKeyRes;

    try {
      const res = await StudyService.patchStudySite(payload, xApiKey);
      if(res.success!==false){
        site.siteId = res.siteId;
        delete site.tmpId;
        delete site.siteIcfFile;
      }
      responses.push(res);
    } catch (err) {
      responses.push(err);
    }
  }

  // Envoi bulk des sites à la plateforme s'il n'y a pas d'erreurs
  const hasErrors = responses.some((r) => r?.success === false);
  if (!hasErrors) {
    try {
      const bulkRes = await StudyService.postBulkSitesPlatform(sites);
      responses.push({ bulkSiteResult: bulkRes });
    } catch (bulkErr) {
      responses.push(bulkErr);
    }
  }

  return responses;
};

const studyExist = async (studyId) => {
  try {
    const response = await StudyService.studyExist(studyId);
    return response;
  } catch (error) {
    return {
      success: false,
      message: "Error fetching studyExist",
      fromError: !Config.IN_PROD ? error.message : null,
      errorCode: "study-exist-error",
      errorKey: 912318,
    };
  }
};


//TODO = CETTE FUNCTION N EST PAS LIE AU WEBHOKK 
/**
 * Sends milestones to the backend via the dedicated service.
 * @param {string} studyId - The ID of the study to associate the milestones with.
 * @param {Array<object>} milestones - The array of milestone objects to send.
 * @returns {Promise<object>} The result of the milestone sending operation.
 */
const addMilestonesToStudy = async (studyId, milestones) => {
  console.log("=== addMilestonesToStudy controller called === network/controllers/study.controller.js ===")
  console.dir({ studyId, milestones }, { depth: null, colors: true })
  console.log("=================================")
  try {
    // Call the new service function to send the milestones
    const response = await StudyService.addMilestones(studyId, milestones)
    console.log('=== response === study.controller.js === key: 096927 ===');
    console.dir(response, { depth: null, colors: true })
    console.log('=================================');
    return response // Return the service response (success/failure)
  } catch (error) {
    console.error("Error in addMilestonesToStudy controller:", error)
    return {
      success: false,
      message: "Error sending milestones",
      fromError: !Config.IN_PROD ? error.message : null,
      errorCode: "add-milestones-controller-error",
      errorKey: 100006, // Use a new error key
    }
  }
}


/**
 * Controller to handle adding a single milestone to a study.
 * @param {string} studyId - The UUID of the study
 * @param {object} milestone - The milestone payload
 * @returns {Promise<object>} Standardized success or error response
 */
/** ------------------ cmt 295662 ------------------
const addMilestoneToStudyById = async (studyId, milestone) => {
  console.log("=== CONTROLLER === study.controller.js === key: 711928 ===")
  console.log("addMilestoneToStudy →", { studyId, milestone })

  if (!studyId || !milestone || !milestone.master_icf_id) {
    console.error("Missing parameters in addMilestoneToStudy")
    return {
      success: false,
      message: "Missing studyId or milestone or master_icf_id",
      errorCode: "missing-params-addmilestone",
      errorKey: 711928,
    }
  }

  const response = await StudyService.addMilestoneToStudy(studyId, milestone)

  if (response?.success === false) {
    console.error("Failed to add milestone →", response)
    return {
      success: false,
      message: response.message || "Unknown error while adding milestone",
      errorCode: response.errorCode || "add-milestone-failed",
      errorKey: 711929,
    }
  }

  console.log("Milestone successfully added →", response.data)
  return {
    success: true,
    data: response.data,
  }
}
*-------------------------------------------------*/



/**
 * Frontend controller pour mettre à jour une milestone.
 * @param {object} params
 * @param {string} params.studyId – L’UUID de l’étude.
 * @param {string} params.milestone_id – L’UUID de la milestone.
 * @param {string} [params.name] – Nouveau nom de la milestone.
 * @param {string} [params.description] – Nouvelle description.
 * @param {string} [params.mandatory] – Nouveau statut.
 * @returns {Promise<object|null>} – Résultat de mise à jour ou erreur normalisée.
 */
const updateMilestoneById = async ({ studyId, milestone_id, name, description, mandatory }) => {
  console.log('=== { studyId, milestone_id, name, description, mandatory } === study.controller.js === key: 694274 ===');
  console.dir({ studyId, milestone_id, name, description, mandatory }, { depth: null, colors: true })
  console.log('=================================');

  if (!studyId || !milestone_id) {
    console.warn("⚠️ studyId ou milestone_id manquant dans updateMilestoneById");
    return {
      success: false,
      message: "Champs requis manquants: studyId ou milestone_id",
      errorCode: "missing-study-or-milestone-id",
      errorKey: 271904,
    };
  }

  try {
    const response = await StudyService.updateMilestoneById(studyId, milestone_id, { name, description, mandatory });

    console.log("=== Réponse backend === study.controller.js === key: 271905 ===");
    console.dir(response, { depth: null, colors: true });
    console.log("=================================");

    return response;
  } catch (error) {
    console.error(" Erreur dans updateMilestoneById controller:", error);
    return {
      success: false,
      message: "Erreur lors de la mise à jour de la milestone",
      fromError: !Config.IN_PROD ? error.message : null,
      errorCode: "update-milestone-controller-error",
      errorKey: 271906,
    };
  }
};



/**
 * Frontend controller pour supprimer une milestone.
 * @param {string} studyId – L’UUID de l’étude.
 * @param {string} milestone_id – L’UUID de la milestone.
 * @returns {Promise<object|null>} – Résultat de suppression ou erreur normalisée.
 */
const deactivateMilestoneById = async (studyId, milestone_id) => {
  console.log("=== deactivateMilestoneById === study.controller.js === key: 349922 ===");
  console.log(" studyId:", studyId);
  console.log(" milestone_id:", milestone_id);
  console.log("=================================");

  if (!studyId || !milestone_id) {
    console.warn(" studyId ou milestone_id manquant dans deactivateMilestoneById");
    return {
      success: false,
      message: "Champs requis manquants: studyId ou milestone_id",
      errorCode: "missing-study-or-milestone-id",
      errorKey: 349923,
    };
  }

  try {
    const response = await StudyService.deactivateMilestoneById(studyId, milestone_id);

    console.log("=== Réponse backend === study.controller.js === key: 349924 ===");
    console.dir(response, { depth: null, colors: true });
    console.log("=================================");

    return response;
  } catch (error) {
    console.error(" Erreur dans deactivateMilestoneById controller:", error);
    return {
      success: false,
      message: "Erreur lors de la suppression de la milestone",
      fromError: !Config.IN_PROD ? error.message : null,
      errorCode: "deactivate-milestone-controller-error",
      errorKey: 349925,
    };
  }
};


/**
 * Récupère un document protocole depuis le backend (qui renvoie un JSON de Buffer)
 * et l'affiche dans un nouvel onglet.
 * @param {string} studyId - L'ID de l'étude associée au protocole.
 * @param {string} protocolId - L'ID du protocole à afficher.
 * @returns {Promise<object>} Un objet indiquant le succès ou l'échec de l'opération.
 */
const getProtocolDocumentAndDisplay = async (studyId, protocolId) => {
  try {
    const session = getSession();

    if (!session?.user?.email) {
      return {
        success: false,
        message: "Utilisateur non authentifié ou email manquant.",
        errorKey: 900006,
      };
    }

    const hashedEmail = await sha256(session.user.email);
    const tmpKeyRes = await AuthService.getTmpApiKey(hashedEmail);

    const xApiKey =
      typeof tmpKeyRes === "string"
        ? tmpKeyRes
        : tmpKeyRes?.data || tmpKeyRes?.apiKey;

    if (!xApiKey) {
      return {
        success: false,
        message: "Échec de la récupération de la clé API temporaire.",
        errorKey: 900007,
      };
    }

    const response = await StudyService.getProtocolDocumentData(studyId, protocolId, xApiKey);

    console.log("=== Réponse complète du service StudyService.getProtocolDocumentData ===");
    console.dir(response, { depth: null, colors: true });
    console.log("======================================================================");

    if (!response.success || !response.data) {
      return {
        success: false,
        message: response.message || "Échec de la récupération des données du document protocole.",
        errorKey: 900003,
      };
    }

    const pdfBlob = response.data;

    if (pdfBlob instanceof Blob && pdfBlob.type === "application/pdf") {
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, "_blank");
      return { success: true, message: "Document PDF affiché avec succès." };
    } else {
      return {
        success: false,
        message: "Format de données PDF inattendu reçu du backend.",
        errorKey: 900004,
      };
    }
  } catch (error) {
    console.error("Erreur interne lors de l'affichage du document protocole:", error);


    if (error.response?.data instanceof ArrayBuffer) {
      const decoded = new TextDecoder("utf-8").decode(error.response.data);
      console.error("Contenu de l'erreur (décodé):", decoded);
    }

    return {
      success: false,
      message: "Erreur interne lors de l'affichage du document protocole.",
      fromError: !Config.IN_PROD ? error.message : null,
      errorKey: 900005,
    };
  }
};

/**
 * Controller frontend pour récupérer les détails de consentement d’un patient.
 * @param {string} patientId – L’UUID du patient.
 * @returns {Promise<object|null>} – Données de consentement ou erreur normalisée.
 */
const getPatientConsentDetails = async (patientId) => {
  console.log("=== patientId === consent.controller.js === key: 615048 ===");
  console.log("→ patientId reçu:", patientId);
  console.log("→ Type:", typeof patientId);
  console.log("=================================");

  if (!patientId) {
    console.warn("⚠️ patientId manquant dans getPatientConsentDetails controller");
    return {
      success: false,
      message: "Champs requis manquants: patientId",
      errorCode: "missing-patient-id",
      errorKey: 615049,
    };
  }

  try {
    //  Appel avec patientId comme string directe
    const response = await StudyService.getPatientConsentDetails(patientId);

    console.log("=== response === consent.controller.js === key: 615050 ===");
    console.dir(response, { depth: null, colors: true });
    console.log("=================================");

    if(response.study_id){
      State.setValue(CurrentStudyState.STUDY_ID, response.study_id);
     // setInSession("participant", response);
    }

    return response;
  } catch (error) {
    console.error("❌ Erreur dans getPatientConsentDetails controller:", error);
    return {
      success: false,
      message: "Erreur lors de la récupération des informations de consentement",
      fromError: !Config.IN_PROD ? error.message : null,
      errorCode: "get-patient-consent-controller-error",
      errorKey: 615051,
    };
  }
};

const getPatientConsentDetailsByParticipantId = async (participantId) => {
  console.log("=== participantId === consent.controller.js === key: 615052 ===");
  console.log("→ participantId reçu:", participantId);
  console.log("→ Type:", typeof participantId);
  console.log("=================================");

  if (!participantId) {
    console.warn("⚠️ participantId manquant dans getPatientConsentDetailsByParticipantId controller");
    return {
      success: false,
      message: "Champs requis manquants: participantId",
      errorCode: "missing-participant-id",
      errorKey: 615053,
    };
  }

  try {
    const response = await StudyService.getPatientConsentDetailsByParticipantId(participantId);

    console.log("=== response === consent.controller.js === key: 615054 ===");
    console.dir(response, { depth: null, colors: true });
    console.log("=================================");

    if(response.study_id){
      State.setValue(CurrentStudyState.STUDY_ID, response.study_id);
    }

    return response;
  } catch (error) {
    console.error("❌ Erreur dans getPatientConsentDetailsByParticipantId controller:", error);
    return {
      success: false,
      message: "Erreur lors de la récupération des informations de consentement",
      fromError: !Config.IN_PROD ? error.message : null,
      errorCode: "get-patient-consent-by-participant-controller-error",
      errorKey: 615055,
    };
  }
};



/**
 * Controller to update general study settings (title, duration, threshold).
 * @param {object} params
 * @param {string} params.studyId
 * @param {string} params.title
 * @param {string} params.estimated_duration
 * @param {number} params.threshold_of_consenting_participants
 * @returns {Promise<object>}
 */
const updateStudyGeneralSettingsCRO = async ({ studyId, title, estimated_duration, threshold_of_consenting_participants }) => {
  try {
    console.log("[Controller] updateStudyGeneralSettingsCRO - Input:", {
      studyId, title, estimated_duration, threshold_of_consenting_participants
    });

    const response = await StudyService.updateStudyGeneralSettings({
      studyId,
      title,
      estimated_duration,
      threshold_of_consenting_participants,
    });

    console.log(" [Controller] updateStudyGeneralSettingsCRO - Response:", response);
    return response;
  } catch (error) {
    console.error(" [Controller] updateStudyGeneralSettingsCRO - Error:", error);
    return {
      success: false,
      message: "Error updating general study settings",
      errorKey: 672304,
      fromError: !Config.IN_PROD ? error.message : null,
    };
  }
};


/**
 * Frontend controller pour ajouter un nouveau Master ICF à une étude existante.
 * @param {string} studyId – L’UUID de l’étude.
 * @param {string} name – Le nom / titre de la version du Master ICF.
 * @returns {Promise<object|null>} – Données du Master ICF créé ou erreur normalisée.
 */
const addMasterIcfToStudy = async (studyId, name) => {
  console.log("=== addMasterIcfToStudy === study.controller.js === key: 762106 ===");
  console.log("→ studyId reçu:", studyId);
  console.log("→ name reçu:", name);
  console.log("=================================");

  if (!studyId || !name) {
    console.warn("⚠️ Champs requis manquants dans addMasterIcfToStudy");
    return {
      success: false,
      message: "Champs requis manquants: studyId ou name",
      errorCode: "missing-studyId-or-name",
      errorKey: 762107,
    };
  }

  try {
    const response = await StudyService.addMasterIcfToStudy(studyId, name);

    console.log("=== Réponse backend === study.controller.js === key: 762108 ===");
    console.dir(response, { depth: null, colors: true });
    console.log("=================================");

    return response;
  } catch (error) {
    console.error("❌ Erreur dans addMasterIcfToStudy controller:", error);
    return {
      success: false,
      message: "Erreur lors de l’ajout d’un Master ICF à l’étude",
      fromError: !Config.IN_PROD ? error.message : null,
      errorCode: "add-master-icf-controller-error",
      errorKey: 762109,
    };
  }
};


/**
 * Supprime un Master ICF d’une étude.
 * @param {string} studyId – L’UUID de l’étude.
 * @param {string} masterIcfId – L’UUID du Master ICF.
 * @returns {Promise<object>} – Résultat de suppression.
 */
const deactivateMasterIcfFromStudy = async (studyId, masterIcfId) => {
  console.log("deactivateMasterIcfFromStudy controller – study:", studyId, "icf:", masterIcfId);

  if (!studyId || !masterIcfId) {
    console.warn(" studyId ou masterIcfId manquant dans deactivateMasterIcfFromStudy");
    return {
      success: false,
      message: "Champs requis manquants: studyId ou masterIcfId",
      errorCode: "missing-study-or-icf-id",
      errorKey: 531098,
    };
  }

  try {
    const response = await StudyService.deactivateMasterIcfFromStudy(studyId, masterIcfId);

    console.log(" Résultat du backend:", response);
    return response;
  } catch (error) {
    console.error(" Erreur dans deactivateMasterIcfFromStudy controller:", error);
    return {
      success: false,
      message: "Erreur lors de la suppression du Master ICF",
      fromError: !Config.IN_PROD ? error.message : null,
      errorCode: "deactivate-master-icf-controller-error",
      errorKey: 531099,
    };
  }
};

/**
 * Controller frontend pour clôturer une étude.
 * @param {string} studyId – L’UUID de l’étude à clôturer.
 * @returns {Promise<object|null>} – Résultat de l’opération ou erreur normalisée.
 */
const closeStudyById = async (studyId) => {
  console.log("=== closeStudyById === study.controller.js === key: 804233 ===");
  console.log("→ studyId reçu:", studyId);
  console.log("→ Type:", typeof studyId);
  console.log("=================================");

  if (!studyId) {
    console.warn("⚠️ studyId manquant dans closeStudyById");
    return {
      success: false,
      message: "Champs requis manquants: studyId",
      errorCode: "missing-study-id",
      errorKey: 804234,
    };
  }

  try {
    const response = await StudyService.closeStudyById(studyId);

    console.log("=== Réponse backend === study.controller.js === key: 804235 ===");
    console.dir(response, { depth: null, colors: true });
    console.log("=================================");

    return response;
  } catch (error) {
    console.error(" Erreur dans closeStudyById controller:", error);
    return {
      success: false,
      message: "Erreur lors de la clôture de l’étude",
      fromError: !Config.IN_PROD ? error.message : null,
      errorCode: "close-study-controller-error",
      errorKey: 804236,
    };
  }
};

/**
 * Frontend controller pour récupérer les mappings d’un Master ICF.
 * @param {string} masterIcfId – L’UUID du Master ICF.
 * @returns {Promise<object>} – Données de mapping ou erreur normalisée.
 */
const getMasterIcfMappings = async (masterIcfId) => {
  console.log("=== getMasterIcfMappings === study.controller.js === key: 716231 ===");
  console.log("→ masterIcfId reçu:", masterIcfId);
  console.log("→ Type:", typeof masterIcfId);
  console.log("=================================");

  if (!masterIcfId) {
    console.warn("⚠️ masterIcfId manquant dans getMasterIcfMappings");
    return {
      success: false,
      message: "Champs requis manquants: masterIcfId",
      errorCode: "missing-master-icf-id",
      errorKey: 716232,
    };
  }

  try {
    const response = await StudyService.getMasterIcfMappings(masterIcfId);

    console.log("=== Réponse backend === study.controller.js === key: 716233 ===");
    console.dir(response, { depth: null, colors: true });
    console.log("=================================");

    return response;
  } catch (error) {
    console.error("❌ Erreur dans getMasterIcfMappings controller:", error);
    return {
      success: false,
      message: "Erreur lors de la récupération des mappings du Master ICF",
      fromError: !Config.IN_PROD ? error.message : null,
      errorCode: "get-master-icf-mappings-controller-error",
      errorKey: 716234,
    };
  }
};

/**
 * Remplace les mappings pour un Master ICF donné (supprime tous les anciens et insère les nouveaux).
 * @param {string} masterIcfId – L’UUID du Master ICF.
 * @param {Array<{id: string, masterIcfId: string, milestoneId: string, studyId: string}>} items – Les mappings à enregistrer.
 * @returns {Promise<object>} – Résultat de l’opération (succès ou erreur).
 */
const replaceMasterIcfMappings = async (masterIcfId, items) => {
  
  console.log('=== masterIcfId === study.controller.js === key: 402105 ===');
  console.dir(masterIcfId, { depth: null, colors: true })
  console.dir(items, { depth: null, colors: true })
  console.log('=================================');



  if (!masterIcfId || !Array.isArray(items)) {
    return {
      success: false,
      message: "Paramètres manquants ou invalides",
      errorCode: "invalid-replace-mapping-input",
      errorKey: 716216,
    };
  }

  try {
    const response = await StudyService.replaceMasterIcfMappings(masterIcfId, items);

    console.log("=== Réponse backend === key: 716217 ===");
    console.dir(response, { depth: null, colors: true });
    console.log("=================================");

    return response;
  } catch (error) {
    console.error("Erreur dans replaceMasterIcfMappings controller:", error);
    return {
      success: false,
      message: "Erreur lors de la mise à jour des mappings",
      errorCode: "replace-mapping-controller-error",
      errorKey: 716218,
      fromError: !Config.IN_PROD ? error.message : null,
    };
  }
};








const StudyController = {
  getStudiesByUserId,
  registerStudy,
  getStudyMetricsCRO,
  getStudyPatientsCRO,
  getStudyGeneralSettingsCRO,
  getMasterIcfSettingsCRO,
  getSiteSettingsCRO,
  getRoleManagementCRO,
  getInvestigatorStudiesByUserId,
  getInvestigatorStudyOverview,
  getInvestigatorPatientsManagement,
  queuePatchProtocolVersions,
  queuePatchSites,
  studyExist,
  addMilestonesToStudy,
  getProtocolDocumentAndDisplay,
  getStudiesByEntityId,
  getPatientConsentDetails,
  getPatientConsentDetailsByParticipantId,
  updateStudyGeneralSettingsCRO,
  addMasterIcfToStudy,
  deactivateMasterIcfFromStudy,
  closeStudyById,
  //addMilestoneToStudyById,
  updateMilestoneById,
  deactivateMilestoneById,
  getMasterIcfMappings,
  replaceMasterIcfMappings,
  updateProtocolVersionFile,
};

export default StudyController;
